<template>
  <div>
    <!-- #region 進階篩選-公司行業類別-彈窗 -->
    <v-dialog
      v-model="industryDialogComp.show"
      scrollable
      width="500px"
      @click:outside="CloseIndustryDialog()"
    >
      <v-card>
        <!-- header -->
        <v-card-title class="px-4">
          <div class="font-weight-black">
            {{ industryDialogComp.title }}
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="CloseIndustryDialog()">
            <v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <!-- #region 搜尋框 -->
        <div class="px-4 mb-5">
          <v-text-field
            @keyup.enter="$event.target.blur()"
            @change="SearchIndustry()"
            v-model="industryDialogComp.search.value"
            append-icon="mdi-magnify"
            :label="industryDialogComp.search.lable"
            outlined
            clearable
            hide-details
            dense
          >
          </v-text-field>
        </div>

        <!-- #endregion -->
        <!-- body -->
        <v-card-text style="max-height: 400px; min-height: 250px" class="pa-0">
          <v-tabs-items v-model="tab" ref="tabs">
            <!-- #region 大類別 -->
            <v-tab-item>
              <div class="px-4 pt-2 black--text font-weight-black">
                {{ industryDialogComp.sub }}
              </div>
              <div v-for="(x, index) in industryDialogComp.datas" :key="x.id">
                <v-btn
                  class="d-flex justify-between text-body-1 py-6"
                  text
                  block
                  @click="SwitchTab(index + 1)"
                >
                  <div>{{ x.text }}</div>
                  <v-spacer></v-spacer>
                  <v-badge
                    v-if="
                      industryDialogComp.statistics[x.id] !== undefined &&
                      industryDialogComp.statistics[x.id] !== 0
                    "
                    color="red accent-2"
                    :content="industryDialogComp.statistics[x.id]"
                    left
                    inline
                  >
                  </v-badge>
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-divider />
              </div>
            </v-tab-item>
            <!-- #endregion -->
            <!-- #region 各細類 -->
            <v-tab-item v-for="x in industryDialogComp.datas" :key="x.id">
              <v-btn
                class="d-flex justify-start text-body-1 mt-5 px-3"
                block
                @click="BackAllIndustry()"
              >
                <v-icon color="grey darken-1">mdi-chevron-left</v-icon>
                <div class="ml-3">{{ x.text }}</div>
              </v-btn>
              <v-checkbox
                @change="IndustrySelectedAll(x.id)"
                :input-value="IndustryAllInTemporarySelected(x.id)"
                :label="x.text"
                class="mx-4 my-3 py-0"
                hide-details
              >
              </v-checkbox>
              <v-divider></v-divider>
              <div v-for="y in x.children" :key="y.id">
                <!-- vuetify的checkbox太多會延遲 -->
                <!-- <v-checkbox
                  @change="IndustryToggle(y.id)"
                  :input-value="IndustryInTemporarySelected(y.id)"
                  :label="y.text"
                  class="ml-12 my-3 py-0"
                  hide-details
                >
                </v-checkbox> -->

                <div class="d-flex align-center">
                  <input
                    type="checkbox"
                    v-model="industryDialogComp.temporarySelected"
                    :value="y.id"
                    :id="y.text"
                    class="ml-12 my-3 py-0 custom-input"
                    style="cursor: pointer"
                  />
                  <label :for="y.text" class="text-body-2 ml-2 custom-label">{{
                    y.text
                  }}</label>
                </div>

                <v-divider />
              </div>
            </v-tab-item>
            <!-- #endregion -->
            <!-- #region 搜尋篩選結果 -->
            <v-tab-item>
              <!-- #region 搜不到顯示圖 -->
              <div
                v-if="!totalIndustrayFlag"
                align="center"
                class="black--text"
              >
                <v-img
                  :src="empty.img"
                  contain
                  max-height="160"
                  max-width="190"
                  class="mb-4"
                ></v-img>
                <div class="mb-1 text-h6 font-weight-black">
                  {{ empty.title }}
                </div>
                <div class="mb-4 text--secondary">{{ empty.sub }}</div>
              </div>
              <!-- #endregion -->
              <!-- #region 搜索分類結果 -->
              <div class="black--text">
                <template v-for="x in industryDialogComp.tempDatas">
                  <div
                    v-if="IndustrySearchFilter(x.children).length > 0"
                    class="px-4 font-weight-black"
                    :key="x.id"
                  >
                    {{ x.text }}
                  </div>
                  <div
                    v-for="y in IndustrySearchFilter(x.children)"
                    :key="y.id"
                    class="mb-4"
                  >
                    <v-checkbox
                      @change="IndustryToggle(y.id)"
                      :input-value="IndustryInTemporarySelected(y.id)"
                      :label="y.text"
                      class="mx-3 my-3 py-0"
                      hide-details
                    >
                    </v-checkbox>
                    <v-divider></v-divider>
                  </div>
                </template>
              </div>
              <!-- #endregion -->
            </v-tab-item>
            <!-- #endregion -->
          </v-tabs-items>
        </v-card-text>
        <!-- footer -->
        <v-card-actions class="py-4">
          <v-spacer></v-spacer>
          <v-expand-x-transition>
            <v-card v-show="tab === 0" height="100%" elevation="0">
              <v-btn text class="mr-2" @click="IndustrySelectedClear()">
                {{ industryDialogComp.clear }}
              </v-btn>
            </v-card>
          </v-expand-x-transition>
          <v-btn color="primary" @click="IndustrySelectedConfirmed()">
            {{ industryDialogComp.confirm }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- #endregion -->
  </div>
</template>

<script>
import industryJson from "@/assets/Industry.json";

import { IndustryCategory_Get } from "@/apis/api";

export default {
  props: {
    open: Boolean,
    clear: Boolean,
    originList: Array,
  },
  data() {
    return {
      empty: {
        img: require("@/assets/image/ads/Empty.svg"),
        title: "未找到結果",
        sub: "請重新輸入其他的關鍵字",
      },
      industryDialogComp: {
        show: false,
        title: "選擇公司行業類別",
        sub: "公司行業類別列表",
        clear: "清除全部",
        confirm: "選擇完成",
        datas: [],
        tempDatas: [],
        selected: [],
        temporarySelected: [],
        search: {
          lable: "搜尋行業名稱",
          value: "",
          list: [],
        },
        statistics: {},
      },
      tab: 0,
      industrySlicedDatas: [],
      totalIndustraySearched: 0,
      totalIndustrayFlag: false,
    };
  },
  mounted() {
    this.IndustryCategory_Get_API();
  },
  watch: {
    open() {
      if (this.open) {
        this.OpenIndustryDialog();
        if (this.originList) {
          this.industryDialogComp.temporarySelected = this.originList;
        }
        this.IndustryStatistics();
      }
    },
    clear() {
      if (this.clear) this.IndustrySelectedClear();
    },
    "industryDialogComp.search.value"(newV) {
      if (!newV) {
        this.industryDialogComp.tempDatas = [];
        this.SwitchTab(0);
        this.IndustryStatistics();
        setTimeout(() => {
          this.industryDialogComp.tempDatas = this.industryDialogComp.datas;
        }, 10);
      }
    },
    tab(newV) {
      if (newV === 0) this.industryDialogComp.search.value = "";
    },
  },
  methods: {
    //#region *** 公司行業別資料處裡 functions

    //#region 撈 公司行業類別 API
    IndustryCategory_Get_API() {
      IndustryCategory_Get()
        .then((res) => {
          console.log(res.data);
          this.IndustryCategoryFormat(res.data);
        })
        .catch((err) => {
          console.log(err);
          this.IndustryCategoryFormat(industryJson);
        });
    },
    //#endregion

    //#region 重組資料
    IndustryCategoryFormat(datas) {
      datas.forEach((x) => {
        let newFormat = {
          id: x.id,
          text: x.text,
          layer: x.layer,
          children: null,
        };
        let lastChildren = [];
        this.IndustryCategoryRecursive(x.children, lastChildren);

        // 太多筆 切陣列 之後再組回去
        let sliced = this.SliceOverLengthList(lastChildren);

        newFormat.children = sliced.sl1;
        this.industryDialogComp.datas.push(newFormat); // 原陣列或原陣列切割的前n%長度的陣列
        this.industryDialogComp.tempDatas.push(newFormat);

        this.industrySlicedDatas.push({ id: x.id, children: sliced.sl2 }); // 其餘100-n %陣列
      });
    },
    //#endregion

    //#region 遞迴撈資料
    IndustryCategoryRecursive(list, lastChildren) {
      list.forEach((x) => {
        if (x.children === null) {
          lastChildren.push(x);
          return;
        }
        this.IndustryCategoryRecursive(x.children, lastChildren);
      });
    },
    //#endregion

    //#region 切割過長陣列
    SliceOverLengthList(originalList) {
      if (originalList.length < 100) return { sl1: originalList, sl2: null };
      let slicedList1 = originalList.slice(0, originalList.length / 8);
      let slicedList2 = originalList.slice(
        originalList.length / 8,
        originalList.length
      );
      return { sl1: slicedList1, sl2: slicedList2 };
    },
    //#endregion

    //#region 還原切割過的陣列
    ReductionSlicedList(listId) {
      let flag = this.industrySlicedDatas.some((x) => x.id === listId);
      if (!flag) return;
      this.industrySlicedDatas.forEach((x) => {
        if (x.id !== listId) return;
        this.industryDialogComp.datas.forEach((y) => {
          if (y.id !== listId) return;
          if (x.children === null) return;
          y.children = y.children.concat(x.children); // 組合
        });
      });
    },
    //#endregion

    //#region 切換tab
    SwitchTab(tabId) {
      this.tab = tabId;
      // 滾動到指定ref : https://stackoverflow.com/questions/55251902/vue-js-how-to-set-scroll-position-back-to-top
      if (this.$refs.tabs !== undefined)
        this.$refs.tabs.$el.scrollIntoView({ behavior: "smooth" });

      this.industrySlicedDatas.forEach((y) => {
        if (tabId === 0) {
          // 返回總分類時 切陣列
          let sliced = this.SliceOverLengthList(
            this.industryDialogComp.datas.find((x) => x.id === y.id).children
          ).sl1;
          // 指向回去
          this.industryDialogComp.datas.find((x) => x.id === y.id).children =
            sliced;
        } else {
          // 還原切割過的陣列
          setTimeout(() => {
            this.ReductionSlicedList(y.id);
          }, 100);
        }
      });
    },
    //#endregion

    //#endregion

    //#region *** 公司行業別 functions

    //#region 關閉公司行業類別彈窗
    CloseIndustryDialog() {
      this.industryDialogComp.show = false;
      this.$emit("close", true);
      this.SwitchTab(0);
      // 延遲顯示 為配合過場動畫
      setTimeout(() => {
        this.IndustrySelectedClear();
      }, 200);
    },
    //#endregion

    //#region 開啟公司行業類別彈窗
    OpenIndustryDialog() {
      this.industryDialogComp.temporarySelected = [];
      this.industryDialogComp.selected.forEach((x) => {
        this.industryDialogComp.temporarySelected.push(x);
      });

      this.industryDialogComp.show = true;
      this.SwitchTab(0);
      this.IndustryStatistics();
    },
    //#endregion

    //#region 選擇完成細項
    IndustrySelectedConfirmed() {
      this.IndustryStatistics();
      this.industryDialogComp.selected =
        this.industryDialogComp.temporarySelected;
      this.$emit("list", this.industryDialogComp.selected);
      this.$emit("formatList", this.industrySelectedFormat());

      // 延遲顯示 為配合過場動畫
      setTimeout(() => {
        this.industryDialogComp.temporarySelected = [];
      }, 200);

      this.industryDialogComp.show = false;
      this.SwitchTab(0);
    },
    //#endregion

    //#region 清除全部已選細項
    IndustrySelectedClear() {
      this.industryDialogComp.temporarySelected = [];
      this.industryDialogComp.statistics = {};
      this.industryDialogComp.selected = [];
    },
    //#endregion

    //#region 返回全部行業別選單
    BackAllIndustry() {
      this.IndustryStatistics();
      this.SwitchTab(0);
    },
    //#endregion

    //#region 已選細項統計
    IndustryStatistics() {
      for (var i = 0; i < this.industryDialogComp.datas.length; i++) {
        let nowLetter = String.fromCharCode(65 + i);

        this.industryDialogComp.statistics[nowLetter] = 0;
        this.industryDialogComp.temporarySelected.forEach((x) => {
          if (x.includes(nowLetter)) {
            this.industryDialogComp.statistics[nowLetter]++;
          }
        });
      }
    },
    //#endregion

    //#region 手動切換checkbox的狀態
    IndustryToggle(id) {
      if (this.industryDialogComp.temporarySelected.includes(id)) {
        let index = this.industryDialogComp.temporarySelected.indexOf(id);
        if (index > -1)
          this.industryDialogComp.temporarySelected.splice(index, 1);
      } else {
        this.industryDialogComp.temporarySelected.push(id);
      }
    },
    //#endregion

    //#region 切換checkbox 的狀態
    IndustryInTemporarySelected(id) {
      if (this.industryDialogComp.temporarySelected.includes(id)) return true;
      else false;
    },
    //#endregion

    //#region 切換全選checkbox 的狀態
    IndustryAllInTemporarySelected(id) {
      let father = this.industryDialogComp.datas.find((x) => x.id === id);
      let myChildren = this.industryDialogComp.temporarySelected.filter((x) =>
        x.includes(id)
      );
      if (father.children.length === myChildren.length) return true;
      return false;
    },
    //#endregion

    //#region 細項全選
    IndustrySelectedAll(id) {
      let father = this.industryDialogComp.datas.find((x) => x.id === id);
      let myChildren = this.industryDialogComp.temporarySelected.filter((x) =>
        x.includes(id)
      );
      // 如果已全選 => 篩掉屬於大類的
      if (father.children.length === myChildren.length) {
        let filtered = this.industryDialogComp.temporarySelected.filter(
          (x) => !x.includes(id)
        );

        this.industryDialogComp.temporarySelected = filtered;
      } else {
        let list = [];
        father.children.forEach((x) => {
          if (this.industryDialogComp.temporarySelected.find((y) => y == x.id))
            return; // 跳過已存在
          list.push(x.id);
          this.industryDialogComp.temporarySelected.push(x.id);
        });
        // this.industryDialogComp.temporarySelected = list;
      }
    },
    //#endregion

    //#region 搜尋行業別
    SearchIndustry() {
      // 切到最後一頁
      this.totalIndustrayFlag = false;
      if (!this.industryDialogComp.search.value) this.SwitchTab(0);
      else this.SwitchTab(this.industryDialogComp.datas.length + 1);
    },
    //#endregion

    //#region 行業別搜尋篩選資料
    IndustrySearchFilter(list) {
      if (this.tab !== this.industryDialogComp.datas.length + 1) return false;
      let tempList = list;
      let result = tempList.filter((x) =>
        x.text.includes(this.industryDialogComp.search.value)
      );
      if (result.length > 0) this.totalIndustrayFlag = true;
      return result;
    },
    //#endregion

    //#region 行業別 Format
    industrySelectedFormat() {
      let format = [];
      this.industryDialogComp.selected.forEach((x) => {
        this.industryDialogComp.datas.forEach((y) => {
          y.children.forEach((z) => {
            if (z.id === x) format.push(z.text);
          });
        });
      });
      return format;
    },
    //#endregion

    //#endregion
  },
};
</script>

<style scoped>
.custom-input[type="checkbox"] {
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  color: rgba(0, 0, 0, 0.5);
  width: 18px;
  height: 18px;
  border: 2px solid;
  border-radius: 2px;
}

.custom-input[type="checkbox"]:checked {
  appearance: none;
  background-color: #7c4dff;
  margin: 0;
  font: inherit;
  color: #fff;
  border: none;
  -webkit-mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" preserveAspectRatio="none"><polygon points="37,84 20,100 80,159 175,55 160,40 80,127" fill="black"/></svg>')
      0/100% 100%,
    linear-gradient(#fff, #fff);
  -webkit-mask-composite: destination-out;
  mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" preserveAspectRatio="none"><polygon points="37,84 20,100 80,159 175,55 160,40 80,127" fill="black"/></svg>')
      0/100% 100%,
    linear-gradient(#fff, #fff);
  mask-composite: exclude;
}

.custom-label {
  color: rgba(0, 0, 0, 0.87);
  width: 80%;
  cursor: pointer;
}
</style>
